/** @jsxImportSource @emotion/react */
import isMobile from 'ismobilejs';
import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import type { Chat } from '@trinity/chat';
import { useAvatarPanel } from '@trinity/chat-components/components/DigitalTwin/AvatarPanel.context';
import { SystemAuthor } from './Message.Author';
import { SystemUserMessageFooterContainer } from './Message.System.Footer';
import { useStyles } from './Message.System.styles';
import { MessageQueryHints } from './QueryHints';

type Props = {
  children: React.ReactNode;
  className?: string;
  bodyStyles?: SerializedStyles;
  hints?: Chat.QueryHint.Item[];
};

export const BasicSystemUserMessage = ({ bodyStyles, children, className, hints = [] }: Props) => {
  const device = isMobile();
  const styles = useStyles();
  const { showAuthor } = useAvatarPanel();

  return (
    <div css={styles.root} className={className}>
      {showAuthor && !device.phone && (
        <div css={styles.authorWrap}>
          <SystemAuthor css={styles.author} />
        </div>
      )}
      <div css={css(styles.body, { width: '100%' }, bodyStyles)}>
        {children}
        {!!hints.length && (
          <SystemUserMessageFooterContainer>
            <MessageQueryHints hints={hints} />
          </SystemUserMessageFooterContainer>
        )}
      </div>
    </div>
  );
};
